import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFileOther = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFileOther needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.1592 7.22538L14.1592 2.22538C14.0146 2.08077 13.8192 2 13.6154 2H5.53846C4.68846 2 4 2.68846 4 3.53846V20.4615C4 21.3115 4.68846 22 5.53846 22H17.8462C18.6962 22 19.3846 21.3115 19.3846 20.4615V7.76923C19.3846 7.56538 19.3038 7.37 19.1592 7.22538ZM14 8.15385C13.5754 8.15385 13.2308 7.80923 13.2308 7.38462V3.46462L17.92 8.15385H14Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFileOther.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFileOther;
